import { PlaceholderPage } from './PlaceholderPage';

export function UploadPage() {
  return (
    <PlaceholderPage
      eyebrow="Step 2 / 4"
      title="Upload Assets"
      description="Upload product imagery, UGC posts, and reference materials. Reach Social runs detection on social posts and writes products straight to the catalog."
      cta="Upload page rebuild — Phase 5"
      legacyHref="/upload.html"
    />
  );
}
